import { Box, Divider, Skeleton, Typography } from '@mui/material'
import React from 'react'

const TotalSummary = ({
  totalSum,
  timeStamp,
  filteredEmployee,
  loadingSummary,
  sx,
  showClaims = true,
}) => {
  const TotalStatutory = ({ title, label }) => {
    return (
      <Box sx={{ width: 'calc(100% / 4)' }}>
        <Typography variant="body2" color="light-gray-text.main">
          {title}
        </Typography>
        {label}
      </Box>
    )
  }
  return (
    <Box
      display="flex"
      sx={{
        height: '200px',
        bgcolor: 'white.main',
        padding: 3,
        boxSizing: 'border-box',
        border: 1,
        borderColor: 'gray-line.main',
        borderRadius: '4.5px',
        ...sx,
      }}
    >
      <Box width="calc(100% * 2 / 5)">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ my: 1, mx: 2 }}
        >
          <Typography color="light-gray-text.main">Effective date</Typography>
          {loadingSummary ? (
            <Skeleton width={100} />
          ) : (
            <Typography>{timeStamp?.effective_date}</Typography>
          )}
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ my: 1, mx: 2 }}
        >
          <Typography color="light-gray-text.main">Payroll type</Typography>
          {loadingSummary ? <Skeleton width={100} /> : <Typography>Regular</Typography>}
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ my: 1, mx: 2 }}
        >
          <Typography color="light-gray-text.main">Employee</Typography>
          {loadingSummary ? (
            <Skeleton width={100} />
          ) : (
            <Typography>{`${filteredEmployee?.length} employees`}</Typography>
          )}
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ bgcolor: 'gray-background.main', p: 2, my: 1 }}
        >
          <Typography color="light-gray-text.main">Total payout</Typography>
          {loadingSummary ? (
            <Skeleton width={100} />
          ) : (
            <Typography>{`RM ${totalSum?.total_payout}`}</Typography>
          )}
        </Box>
      </Box>
      <Divider orientation="vertical" sx={{ mx: 3 }} />
      <Box width="calc(100% * 3 / 5)" display="flex" flexWrap="wrap" rowGap={2}>
        <TotalStatutory
          title="Total EPF Payment"
          label={
            <>
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`EE: RM ${totalSum?.total_epf_employee_contribution}`}</Typography>
              )}
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`ER: RM ${totalSum?.total_epf_employer_contribution}`}</Typography>
              )}
            </>
          }
        />
        <TotalStatutory
          title="Total SOCSO Payment"
          label={
            <>
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`EE: RM ${totalSum?.total_socso_employee_contribution}`}</Typography>
              )}
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`ER: RM ${totalSum?.total_socso_employer_contribution}`}</Typography>
              )}
            </>
          }
        />
        <TotalStatutory
          title="Total SKBBK Payment"
          label={
            <>
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`RM ${
                  totalSum?.total_skbbk_employee_contribution ?? totalSum?.total_skbbk ?? '0.00'
                }`}</Typography>
              )}
            </>
          }
        />
        <TotalStatutory
          title="Total EIS Payment"
          label={
            <>
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`EE: RM ${totalSum?.total_eis_employee_contribution}`}</Typography>
              )}
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`ER: RM ${totalSum?.total_eis_employer_contribution}`}</Typography>
              )}
            </>
          }
        />
        <TotalStatutory
          title="Total MTD Payment"
          label={
            <>
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`RM ${totalSum?.total_mtd_payment}`}</Typography>
              )}
            </>
          }
        />
        <TotalStatutory
          title="Total HRDF Payment"
          label={
            <>
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`RM ${totalSum?.total_hrdf_payment}`}</Typography>
              )}
            </>
          }
        />
        <TotalStatutory
          title="Total NET Salary"
          label={
            <>
              {loadingSummary ? (
                <Skeleton width={100} />
              ) : (
                <Typography>{`RM ${totalSum?.total_net_salaries}`}</Typography>
              )}
            </>
          }
        />
        {showClaims && (
          <TotalStatutory
            title="Total Claim Payment"
            label={
              <>
                {loadingSummary ? (
                  <Skeleton width={100} />
                ) : (
                  <Typography>{`RM ${totalSum?.total_claims ?? '0.00'}`}</Typography>
                )}
              </>
            }
          />
        )}
      </Box>
    </Box>
  )
}

export default TotalSummary
